import { render } from "./client-enrolments-export.vue?vue&type=template&id=3a87cd0e&ts=true"
import script from "./client-enrolments-export.ts?vue&type=script&lang=ts&external"
export * from "./client-enrolments-export.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__